function highlightActiveLinks(selectWrapper) {
  const currentUrl = window.location.href;
  const sidebarLinks = document.querySelectorAll('.dining-menu__sidebar-anchor');
  const selectLinks = document.querySelectorAll('.dining-menu__select-anchor');
  let activeSelectLink = null;

  sidebarLinks.forEach((link) => {
    link.classList.remove('active');

    if (new RegExp(`${link.dataset.slug}[/.]?$`).test(currentUrl)) {
      link.classList.add('active');
    }
  });

  selectLinks.forEach((link) => {
    link.classList.remove('active');
    if (link.href.split('/').slice(-1)[0] === currentUrl.split('/').slice(-2)[0]
      || link.href.split('/').slice(-1)[0] === currentUrl.split('/').slice(-1)[0]) {
      link.classList.add('active');
      activeSelectLink = link;
    }
  });

  if (activeSelectLink && selectWrapper) {
    const selectedText = selectWrapper.querySelector('.dining-menu__select-active');
    if (selectedText) {
      selectedText.textContent = activeSelectLink.textContent;
    }
  }
}

function loadMenuBySlug(slug, selectWrapper) {
  fetch(`${window.ajaxurl}?action=load_menu_by_slug&slug=${slug}`)
    .then((res) => res.json())
    .then((data) => {
      if (data.success) {
        const { title, html } = data.data;
        const container = document.getElementById('linked-page-content');
        if (container) {
          container.innerHTML = html;
        }
        // eslint-disable-next-line no-param-reassign
        selectWrapper.querySelector('.dining-menu__select-active').innerHTML = title;
        highlightActiveLinks(selectWrapper);
      }
    });
}

document.addEventListener('DOMContentLoaded', () => {
  const selectMenuMobile = document.querySelector('.dining-menu__select');
  const linkedPage = document.getElementById('linked-page');
  const links = document.querySelectorAll('.dining-menu__sidebar-anchor, .dining-menu__select-anchor');

  if (linkedPage && links.length) {
    links.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();

        /* eslint-disable */
        const slug = link.dataset.slug;
        if (!slug) return;

        const basePath = window.location.pathname.split('/menus')[0];
        const newUrl = `${basePath}/menus/${slug}`;
        history.pushState(null, '', newUrl);
        /* eslint-enable */

        loadMenuBySlug(slug, selectMenuMobile);
      });
    });

    const match = window.location.pathname.match(/\/menus\/([^/]+)/);
    if (match && match[1]) {
      const slug = match[1];
      loadMenuBySlug(slug, selectMenuMobile);
    }
  }

  if (selectMenuMobile) {
    selectMenuMobile.addEventListener('click', () => {
      const options = document.querySelector('.dining-menu__select-options');
      options.classList.toggle('open');
    });
  }
});

class DiningMenu {
  constructor() {
    this.stickyObserver = null;
    this.selectMenuMobile = document.querySelector('.dining-menu__select');
    this.selectMenuBoxMobile = document.querySelector('.dining-menu__select-box');
    this.stickyTopOffset = -1;
  }

  defineStickyProps = () => {
    this.stickyTopOffset = -1;
    const wpAdminBar = document.getElementById('wpadminbar');
    const headerHeight = 50;

    if (wpAdminBar && window.getComputedStyle(wpAdminBar).position === 'fixed') {
      this.stickyTopOffset += wpAdminBar.offsetHeight;
    }

    this.stickyTopOffset += headerHeight;

    this.selectMenuBoxMobile.style.position = 'sticky';
    this.selectMenuBoxMobile.style.top = `${this.stickyTopOffset}px`;
  };

  detectSticky = () => {
    if (!this.selectMenuBoxMobile || !this.selectMenuMobile) return;

    // Create or find a sentinel element before the sticky box
    let sentinel = this.selectMenuBoxMobile.previousElementSibling;
    if (!sentinel || !sentinel.classList.contains('dining-menu__sticky-sentinel')) {
      sentinel = document.createElement('div');
      sentinel.className = 'dining-menu__sticky-sentinel d-block d-lg-none';
      sentinel.style.height = '1px';
      this.selectMenuBoxMobile.parentNode.insertBefore(sentinel, this.selectMenuBoxMobile);
    }

    // Remove any previous observer
    if (this.stickyObserver) {
      this.stickyObserver.disconnect();
    }

    // Use IntersectionObserver to detect when sentinel leaves viewport (iOS friendly)
    this.stickyObserver = new window.IntersectionObserver(
      ([entry]) => {
        // If not visible, sticky is active
        this.selectMenuMobile.classList.toggle('is-stuck', entry.intersectionRatio === 0);
      },
      {
        root: null,
        threshold: [0],
        rootMargin: `-${this.stickyTopOffset}px 0px 0px 0px`,
      },
    );
    this.stickyObserver.observe(sentinel);
  };

  init = () => {
    document.addEventListener('DOMContentLoaded', () => {
      this.defineStickyProps();
      this.detectSticky();
    });

    window.addEventListener('resize', () => {
      this.defineStickyProps();
      this.detectSticky();
    });
  };
}

const diningMenuObject = new DiningMenu();
diningMenuObject.init();
